/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_OlderInputs */

const en_wc_dl_older = /** @type {(inputs: Wc_Dl_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for an older version? See all releases on GitHub.`)
};

/**
* | output |
* | --- |
* | "Looking for an older version? See all releases on GitHub." |
*
* @param {Wc_Dl_OlderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_older = /** @type {((inputs?: Wc_Dl_OlderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_OlderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_older(inputs)
});
export { wc_dl_older as "wc.dl.older" }